import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 10H14V8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8V10ZM16 10C17.1046 10 18 10.8954 18 12V17C18 18.1046 17.1046 19 16 19H8C6.89543 19 6 18.1046 6 17V12C6 10.8954 6.89543 10 8 10V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8V10Z"
        fill="currentColor"
        fill-opacity="0.4"
      />
    </svg>
  )
}
